export default class RefreshDataState {
    constructor(isReloading, shouldShowMessage, performedUpdate, message) {
        this.is_reloading = isReloading;
        this.should_show_message = shouldShowMessage;
        this.performed_update = performedUpdate;
        this.update_message = message;
    }
}


// WEBPACK FOOTER //
// ./src/models/refreshDataState.js